package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.GameTable
import fr.manyverse.app.domain.repository.GameTableRepository

class CheckCharacterInActiveTableUseCase(
    private val gameTableRepository: GameTableRepository
) {
    suspend operator fun invoke(
        characterId: String,
        userId: String
    ): Result<GameTable?> = gameTableRepository.getActiveTableForCharacter(characterId, userId)
}
